$(function () {
  $("#resetPasswordComponent-form").submit(function (e) {
    e.preventDefault();
    if (!$("#resetPasswordComponent-username").val()) {
      return;
    }
    $("#resetPasswordComponent-submit").attr("disabled", "disabled");
    $('.resetPasswordComponent-confirmMessage').addClass('hidden');
    $('.resetPasswordComponent-sendError').addClass('hidden');
    var token = $(this).find('input[name="__RequestVerificationToken"]', this).val();
    var jqxhr = $.post("/post-reset-mydometic-password", {
      email: $("#resetPasswordComponent-username").val(),
      sitecoreItemId: $("body").data("sc-item"),
      sitecoreLanguageId: $("body").data("sc-language"),
      __RequestVerificationToken: token
    });
    jqxhr.done(function (data) {
      if (!data) {
        $('.resetPasswordComponent-sendError').removeClass('hidden');
        $("#resetPasswordComponent-submit").removeAttr("disabled");
      } else {
        $('.resetPasswordComponent-confirmMessage').removeClass('hidden');
        $('.resetPasswordComponent .form-group').addClass('hidden');
        ;
        $('.resetPasswordComponent .button-row').addClass('hidden');
        ;
      }
    });
    jqxhr.fail(function (request, error) {
      $('.resetPasswordComponent-sendError').removeClass('hidden');
      $("#resetPasswordComponent-submit").removeAttr("disabled");
    });
  });
});